import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Sticky from 'react-stickynode';
import { ThemeProvider } from 'styled-components';
import { Box } from '@design-system/box';
import { Container } from '@design-system/container';
import { Col, Grid, GridRow, } from '@design-system/grid';
import { useBreakpoint, useTheme, useUpdateThemeWithFontBrightness, } from '@design-system/theme';
import { TemplateContainer } from './TemplateContainer';
import { BLOCKS, BlockWrapper, } from '../shared';
import { DEFAULT_ZONE } from '../utils';
const ZONE_IDS = {
    appHeader: 'appHeader',
    left: 'left',
    empty: 'empty',
};
const DEFAULT_ZONES = {
    appHeader: [BLOCKS.appHeader.id],
    left: [BLOCKS.headerControls.id, BLOCKS.filters.id, BLOCKS.tags.id],
    empty: [BLOCKS.emptyContent.id],
};
const TwoColumnsTemplate = ({ hasFilters, offsetRightZone, topicId, variant, zones, }) => {
    var _a, _b;
    const breakpoint = useBreakpoint();
    const theme = useTheme();
    const updatedTheme = useUpdateThemeWithFontBrightness(theme, theme.themeVariables.outboxedFontBrightness);
    return (_jsxs(TemplateContainer, { id: "two-columns-template", children: [!topicId && (_jsx(BlockWrapper, { withShadow: theme.themeVariables.headerSeparatorDisplay && variant !== 'max' && hasFilters, children: zones[ZONE_IDS.appHeader] })), _jsx(Container, { display: "block", height: "auto", pb: 6, children: _jsx(Grid, { rowGap: 0, children: _jsxs(GridRow, { children: [_jsx(Col, { width: { _: 1, l: 4 / 12, xl: 3 / 12 }, children: zones[ZONE_IDS.left] ? (_jsx(Sticky, { bottomBoundary: "#two-columns-template", enabled: ['l', 'xl'].includes(breakpoint), top: "header", children: _jsx(ThemeProvider, { theme: updatedTheme, children: _jsx(Box, { flexDirection: "column", pb: 5, children: (_a = zones[ZONE_IDS.left]) === null || _a === void 0 ? void 0 : _a.map((block, index) => (_jsx(BlockWrapper, { "$emptyStyle": { marginTop: 0 }, mt: 6, children: block }, index))) }) }) })) : null }), _jsxs(Col, { offset: { _: 0, xl: offsetRightZone ? 1 / 12 : 0 }, width: { _: 1, l: 8 / 12, xl: offsetRightZone ? 8 / 12 : 9 / 12 }, children: [(_b = zones[DEFAULT_ZONE]) === null || _b === void 0 ? void 0 : _b.map((block, index) => (_jsx(BlockWrapper, { "$emptyStyle": { marginTop: 0 }, mt: 6, children: block }, index))), zones[ZONE_IDS.empty] && (_jsx(BlockWrapper, { mb: 10, mt: 8, children: zones[ZONE_IDS.empty] }))] })] }) }) })] }));
};
export default {
    id: 'two_columns',
    zones: DEFAULT_ZONES,
    component: TwoColumnsTemplate,
};
//# sourceMappingURL=TwoColumnsTemplate.js.map